'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenExpandCloseButton = function (_Component) {
  (0, _inherits3.default)(FullscreenExpandCloseButton, _Component);

  function FullscreenExpandCloseButton() {
    (0, _classCallCheck3.default)(this, FullscreenExpandCloseButton);
    return (0, _possibleConstructorReturn3.default)(this, (FullscreenExpandCloseButton.__proto__ || (0, _getPrototypeOf2.default)(FullscreenExpandCloseButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullscreenExpandCloseButton, [{
    key: 'closeButtonCreated',
    value: function closeButtonCreated(buttonElement) {
      this.closeButton = buttonElement;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.closeButton && this.props.shoudAutofocus) {
        this.closeButton.focus && this.closeButton.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('button', {
        className: 'fullscreen-icon fullscreen-close ' + this.props.iconClass,
        onClick: function onClick() {
          return _this2.props.onClick();
        },
        tabIndex: this.props.tabIndex,
        'aria-label': this.props.ariaLabel,
        ref: function ref(button) {
          return _this2.closeButtonCreated(button);
        }
      });
    }
  }]);
  return FullscreenExpandCloseButton;
}(_react.Component);

exports.default = FullscreenExpandCloseButton;